import { render, staticRenderFns } from "./RegistrationByEmailForm.vue?vue&type=template&id=ee90780c&scoped=true&"
import script from "./RegistrationByEmailForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationByEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationByEmailForm.vue?vue&type=style&index=0&id=ee90780c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee90780c",
  null
  
)

export default component.exports